export default {
  "cgu": {
    "heroTitle": "Términos y Condiciones de Uso",
    "lastUpdated": "Última actualización: 3 de agosto de 2026",
    "sections": [
      {
        "title": "1. Preámbulo",
        "paragraphs": [
          "Los presentes Términos y Condiciones de Uso (en adelante « TCU ») rigen el acceso y uso del sitio web is-telecom.co (en adelante « el Sitio »), editado por IS TELECOM, empresa registrada en Benín, con sede social en Cotonú, Benín.",
          "Al acceder al Sitio y navegar por sus páginas, el usuario (en adelante « el Usuario ») acepta sin reservas la totalidad de los presentes TCU. Si el Usuario no acepta estas condiciones, se le solicita que no utilice el Sitio."
        ]
      },
      {
        "title": "2. Objeto del Sitio",
        "paragraphs": ["El Sitio tiene por objeto presentar las actividades, servicios y productos ofrecidos por IS TELECOM en los siguientes ámbitos:"],
        "list": [
          "Microrredes fotovoltaicas y electrificación rural",
          "Soluciones de bombeo solar e irrigación",
          "Almacenamiento de energía y baterías de litio",
          "Carga de vehículos eléctricos",
          "Construcción metálica y obra civil",
          "Informática, redes y sistemas de monitoreo",
          "Auditoría y consultoría energética",
          "Telecomunicaciones e infraestructura",
          "Transporte y logística"
        ],
        "paragraphsAfter": [
          "El Sitio también permite a los Usuarios solicitar un presupuesto, contactar a IS TELECOM y consultar información sobre los proyectos realizados por la empresa."
        ]
      },
      {
        "title": "3. Acceso al Sitio",
        "paragraphs": [
          "El acceso al Sitio es gratuito y está abierto a cualquier Usuario con conexión a internet. IS TELECOM implementa los medios necesarios para garantizar la disponibilidad del Sitio 24 horas al día, 7 días a la semana, salvo en casos de fuerza mayor, mantenimiento técnico o actualización que requiera una interrupción temporal.",
          "IS TELECOM se reserva el derecho de modificar, suspender o interrumpir el acceso al Sitio, total o parcialmente, sin previo aviso y sin que ello pueda dar lugar a indemnización alguna."
        ]
      },
      {
        "title": "4. Propiedad Intelectual",
        "paragraphs": [
          "Todos los elementos que componen el Sitio (textos, gráficos, logotipos, iconos, imágenes, videos, sonidos, software, bases de datos, etc.) son propiedad exclusiva de IS TELECOM o de sus socios y están protegidos por las leyes de propiedad intelectual.",
          "Cualquier reproducción, representación, modificación, publicación, adaptación o explotación, total o parcial, de los elementos del Sitio, por cualquier medio, sin la autorización previa y por escrito de IS TELECOM, está estrictamente prohibida y constituye una infracción."
        ]
      },
      {
        "title": "5. Uso del Sitio",
        "paragraphs": ["El Usuario se compromete a utilizar el Sitio de manera leal y conforme a su finalidad. Queda prohibido en particular:"],
        "list": [
          "Utilizar el Sitio con fines ilícitos o fraudulentos",
          "Introducir virus, troyanos, gusanos o cualquier otro software malicioso",
          "Interrumpir o perturbar el acceso al Sitio o a sus servidores",
          "Recopilar datos personales de otros Usuarios sin su consentimiento",
          "Difundir contenidos difamatorios, injuriosos, obscenos o contrarios al orden público"
        ]
      },
      {
        "title": "6. Enlaces de Hipertexto",
        "paragraphs": [
          "El Sitio puede contener enlaces a sitios web de terceros. IS TELECOM no ejerce ningún control sobre el contenido de estos sitios y declina toda responsabilidad en cuanto a su contenido, exactitud o funcionamiento. La activación de estos enlaces es responsabilidad exclusiva del Usuario.",
          "Cualquier creación de un enlace de hipertexto hacia el Sitio debe ser objeto de una autorización previa y por escrito de IS TELECOM. IS TELECOM se reserva el derecho de solicitar la eliminación de cualquier enlace no autorizado."
        ]
      },
      {
        "title": "7. Responsabilidad",
        "paragraphs": [
          "IS TELECOM se esfuerza por garantizar la exactitud y actualización de la información publicada en el Sitio. Sin embargo, IS TELECOM no puede garantizar la exhaustividad, exactitud o ausencia de errores en la información proporcionada. Se invita al Usuario a verificar la exactitud de la información con IS TELECOM antes de tomar cualquier decisión.",
          "IS TELECOM no podrá ser considerada responsable de los daños directos o indirectos resultantes del uso del Sitio, de la imposibilidad de acceder a él, o de la consulta de contenidos procedentes de sitios enlazados."
        ]
      },
      {
        "title": "8. Datos Personales",
        "paragraphs": [
          "IS TELECOM recopila y trata los datos personales de los Usuarios de conformidad con su Política de Privacidad, accesible en el Sitio. Se invita al Usuario a consultar esta política para comprender cómo se recopilan, utilizan y protegen sus datos."
        ]
      },
      {
        "title": "9. Cookies",
        "paragraphs": [
          "El Sitio utiliza cookies y tecnologías similares para mejorar la experiencia de navegación, analizar el tráfico y personalizar el contenido. El Usuario puede gestionar sus preferencias de cookies a través de la configuración de su navegador."
        ]
      },
      {
        "title": "10. Modificación de los TCU",
        "paragraphs": [
          "IS TELECOM se reserva el derecho de modificar los presentes TCU en cualquier momento, en particular para adaptarse a las evoluciones legales, reglamentarias o técnicas. Las modificaciones entrarán en vigor a partir de su publicación en el Sitio. Se invita al Usuario a consultar regularmente los TCU para tomar conocimiento de las posibles modificaciones."
        ]
      },
      {
        "title": "11. Ley Aplicable y Jurisdicción Competente",
        "paragraphs": [
          "Los presentes TCU se rigen por la ley beninesa. En caso de litigio relativo a la interpretación, ejecución o validez de los presentes TCU, las partes se comprometen a buscar una solución amistosa antes de cualquier acción judicial. A falta de acuerdo amistoso, los tribunales competentes de Cotonú, Benín, serán los únicos competentes para conocer del litigio."
        ]
      },
      {
        "title": "12. Contacto",
        "paragraphs": [
          "Para cualquier pregunta relativa a los presentes TCU o al funcionamiento del Sitio, el Usuario puede contactar a IS TELECOM en las siguientes direcciones:"
        ]
      }
    ]
  }
};